/* global jQuery, elementorFrontend */

import { debounce } from '../utils/debounce';

const servicesSpecialCard = () => {
	(function ($) {
		const el = {
			container: '.mi-card--services__container',
			card: '.mi-card--services',
			animation: '.mi-card--windmillAnimation',
			e_template: '.elementor-widget-template',
		};

		let columns = {};
		let cardSettings;

		const init = () => {
			$(function () {
				exec();
			});
		};

		const exec = () => {
			elementorFrontend.hooks.addAction(
				'frontend/element_ready/loop-grid.post',
				function ($scope) {
					if (!$scope.hasClass(el.container.slice(1))) return;

					cardSettings = JSON.parse($scope.attr('data-settings'));

					// Filter only column-related settings
					columns = Object.fromEntries(
						Object.entries(cardSettings).filter(([key]) =>
							key.includes('column'),
						),
					);

					calculateCardSize($scope);
					$(window).on(
						'resize',
						debounce(function () {
							calculateCardSize($scope);
						}, 200),
					);
				},
			);
		};

		const calculateCardSize = ($scope) => {
			const windowWidth = window.innerWidth;

			// Get container and template elements
			const $container = $(el.container).closest('.e-con');
			const $animation = $container.find(el.animation);
			const $template = $animation.closest(el.e_template);

			// Get container gap value
			const containerGap = {
				column: parseFloat(
					window.getComputedStyle($scope.get(0)).columnGap,
				),
				row: parseFloat(window.getComputedStyle($scope.get(0)).rowGap),
			};

			// Get card element and its styles
			const cardEl = $scope.find(el.card).get(0);
			const cardStyles = window.getComputedStyle(cardEl);

			// Calculate padding values
			const cardPadding = {
				top: parseFloat(cardStyles.paddingBlockStart),
				bottom: parseFloat(cardStyles.paddingBlockEnd),
				left: parseFloat(cardStyles.paddingInlineStart),
			};

			// Calculate total card height including padding
			const cardHeight = Math.floor(
				$(cardEl).height() + cardPadding.top + cardPadding.bottom,
			);

			// Set CSS variable for card height
			$container.css('--card-height', `${cardHeight}px`);
			$container.css('padding-bottom', '0px');

			// Set template width based on screen size
			const containerCols =
				windowWidth < 601
					? columns.columns_mobile
					: windowWidth < 1025
					? columns.columns_tablet
					: columns.columns;

			const cols = parseInt(containerCols);
			const offset = cols !== 1 ? containerGap.column : 0;

			$template.width($container.width() / cols - offset);

			if (cols === 1) {
				$container.css(
					'padding-bottom',
					`${cardHeight + containerGap.row}px`,
				);
			}

			// Ensure animation and parent fill available height
			$animation.css('height', '100%');
			$animation.parent().css('height', '100%');

			// Adjust template size and inner element height
			$template.css({
				height: 'var(--card-height)',
			});

			$template.find('.elementor-template').css('height', '100%');
		};

		init();
	})(jQuery);
};

try {
	servicesSpecialCard();
} catch (error) {
	console.error(error);
}
